import { Search, X } from "lucide-react";
import { cn } from "@/lib/cn";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  testId?: string;
}

export const SearchInput = ({
  value,
  onChange,
  placeholder,
  className,
  testId = "search-input",
}: SearchInputProps) => (
  <div className={cn("relative", className)}>
    <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
    <input
      data-testid={testId}
      type="search"
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className="ops-focus h-9 w-full rounded-sm border border-input bg-card pl-9 pr-8 text-sm text-foreground placeholder:text-muted-foreground/80 transition-colors duration-150 hover:border-ring/60"
    />
    {value && (
      <button
        type="button"
        data-testid={`${testId}-clear`}
        onClick={() => onChange("")}
        className="ops-focus absolute right-2 top-1/2 -translate-y-1/2 rounded-sm p-0.5 text-muted-foreground transition-colors duration-150 hover:text-foreground"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    )}
  </div>
);
